export enum AppName {
	'booking' = 'booking',
	'booking-person' = 'booking-person',
	'bookingCalendar' = 'bookingCalendar',
	'chat' = 'chat',
	'evaluation' = 'evaluation',
	'home' = 'home',
	'jobs' = 'jobs',
	'login' = 'login',
	'maintenance' = 'maintenance',
	'maintenance2' = 'maintenance2',
	'notiDispatcher' = 'notiDispatcher',
	'onClient' = 'onClient',
	'password' = 'password',
	'planTemplate' = 'planTemplate',
	'presenceStatus' = 'presenceStatus',
	'report' = 'report',
	'resourceCalendar' = 'resourceCalendar',
	'sheet' = 'sheet',
	'term' = 'term',
	'terminal' = 'terminal',
	'timeline' = 'timeline',
	'timelineTask' = 'timelineTask',
	'timekeeping' = 'timekeeping',
	'workflow' = 'workflow',
	'workflow1' = 'workflow1',
	'workflow2' = 'workflow2',
}

const urlString = window.location.pathname;
const str = urlString.substring(urlString.lastIndexOf("/") + 1, urlString.indexOf(".jsp"));
const appName = Object.values(AppName).filter(x => AppName[x] === str)[0];
if (!appName) {
	console.error('missing AppName')
}

export const getAppName = (): AppName => {
	return appName;
}

export function getAppDiscriminator(): string {
	const appinst = getAppInst()
	if (appinst) return appName + '*' + appinst
	else return appName
}

const params = new URLSearchParams(window.location.search);
const appinst = params.get('appinst');
export const getAppInst = (): string | null => {
	return appinst
}

export function getDeviceForApp() {
	switch (appName) {
		case AppName.terminal:
		case AppName.term:
			return 'appt01'
		default:
			return 'app'
	}
}